//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams, toCopy,getDate} from '@/utils/util.js'
import bottom from '@/assets/img/bottom.png'
import {uploadFile} from '@/utils/auth'
import footerNav from '@/components/footerNav'
import homeTip from '@/components/homeTip'
import {Dialog,Toast} from 'vant';

export default {
  name: "createSendOrderDetail",
  components: {
    footerNav,
    homeTip
  },
  computed: {
  },
  data() {
    return {
      purchaseOrderId:'',
      spuCode:'',
      colorCode:'',
      colorValue:'',
      list:[],
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.purchaseOrderId) {
      this.purchaseOrderId = this.$route.query.purchaseOrderId
      this.spuCode = this.$route.query.spuCode
      this.colorCode = this.$route.query.colorCode
      this.colorValue = this.$route.query.colorValue
      this.queryList()
    }
    // if (this.$route.query.qualityOrderId) {
    //   this.qualityOrderId = this.$route.query.qualityOrderId
    //   this.qualityResultId = this.$route.query.qualityResultId
    // }
    // this.getSpecList()
    // if (this.$route.query.data) {
    //   this.arr = JSON.parse(this.$route.query.data)
    // }
    // if (this.$route.query.redoneOrderId) {
    //   this.redoneOrderId = this.$route.query.redoneOrderId
    // }
    // this.queryOption()
    // this.getSpecList()
    // this.getSendOrder()
  },
  methods: {
    queryList(){
      var queryParams = {
        "purchaseOrderId":this.purchaseOrderId,
        "spuCode":this.spuCode,
        "colorCode":this.colorCode,
        // "spuCodeList":[this.arr[0].spuCode],
        "start":0,
        "size":30,
        "orderRules":[{"orderKey":"t1.spuCode","desc":false},{"orderKey":"t1.colorCode","desc":false}]
      };
      axiosApi.pagePurchaseOrderGoodsList(queryParams).then(response => {
        this.list = response.content.list;
        this.showPopup = true
        // this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
    },
    changeTotal(item){
      if(item.sendSingleBoxNum&&item.sendCtn){
        this.$set(item, 'sendGoodsNum', parseInt(item.sendSingleBoxNum*item.sendCtn))
        // item.sendGoodsNum =
        // console.log(item.sendGoodsNum)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/purchase/createSendOrderDetail.vue